import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
  size?: 'md' | 'lg' | 'xl';
  scrollTo?: string;
  id?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  fullWidth = false,
  size = 'lg',
  scrollTo,
  id,
  href
}: CTAButtonProps) {
  const sizeClasses = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const handleClick = () => {
    // Navigation is handled by global click listener for href buttons
    // This just handles scrollTo and custom onClick
    if (scrollTo) {
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
    if (onClick) {
      onClick();
    }
  };
  return <motion.button id={id} data-mp={href ? 'addtocart-nbb' : undefined} data-href={href} whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`
        relative overflow-hidden font-bold text-white rounded-full shadow-lg
        bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700
        transition-colors duration-300 focus:outline-none focus:ring-4 focus:ring-rose-300
        ${sizeClasses[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-2">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-3">
        {children}
      </span>
      {/* Subtle shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent hover:animate-[shimmer_1.5s_infinite]" data-id="element-4" />
    </motion.button>;
}